var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Address-Book",
    transform: "translate(-302.000000, -437.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(302.357143, 437.375000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7765,17.2329789 C1.84658889,18.2300567 2.67688889,19.0025122 3.6765,18.9999851 L11.5425,18.9999851 C12.5419,19.0025122 13.3726222,18.2300567 13.4425,17.2329789 L14.25,5.69997889 L0.95,5.69997889 L1.7765,17.2329789 Z M15.2,2.37497889 L15.2,3.32497889 C15.2,3.58739 14.9872,3.79997889 14.725,3.79997889 L0.475,3.79997889 C0.212588889,3.79997889 0,3.58739 0,3.32497889 L0,2.37497889 C0,2.11256778 0.212588889,1.89997889 0.475,1.89997889 L4.75,1.89997889 L4.75,0.949978889 C4.75,0.425367778 5.17538889,-2.11111109e-05 5.7,-2.11111109e-05 L9.5,-2.11111109e-05 C10.0246111,-2.11111109e-05 10.45,0.425367778 10.45,0.949978889 L10.45,1.89997889 L14.725,1.89997889 C14.9872,1.89997889 15.2,2.11256778 15.2,2.37497889 L15.2,2.37497889 Z",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIc);
export default __webpack_public_path__ + "static/media/trash-ic.a30486957110d02a54a88d6dee6c5a00.svg";
export { ForwardRef as ReactComponent };